<div mat-dialog-title class="loop-stimuli-dialog__title">
  <div class="mat-dialog-title__content">
    <h2><span>All stimuli</span></h2>
    <span class="mat-dialog-title__content-description">{{ media$().length }} stimuli</span>
  </div>
  <eiq-button
    testId="loop-stimuli-close"
    title="Close all stimuli dialog"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    class="mat-dialog-title__close"
    (clicked)="onClose()"
  />
</div>
<div mat-dialog-content class="empathy-editor loop-stimuli-dialog__content">
  <div class="loop-stimuli-dialog__toolbar">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="loop-stimuli-dialog__search">
      <input
        matInput
        [formControl]="searchControl"
        placeholder="Search by ID, name or filename"
        aria-label="Search by ID, name or filename"
        data-testid="loop-stimuli-search-input"
      />
    </mat-form-field>
    @if (selectedIds$().size) {
      <button mat-stroked-button color="warn" data-testid="loop-stimuli-remove-selected-button" (click)="onRemoveSelected()">
        <span>Remove selected ({{ selectedIds$().size }})</span>
      </button>
    }
  </div>
  <div class="loop-stimuli-dialog__table-container">
    <table mat-table [dataSource]="rows$()" [trackBy]="trackRow" class="loop-stimuli-dialog__table">
      <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="allSelected$()"
            [indeterminate]="someSelected$()"
            aria-label="Select all stimuli on this page"
            data-testid="loop-stimuli-select-all-checkbox"
            (change)="onSelectAll($event.checked)"
          />
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            [checked]="row.selected"
            [attr.data-testid]="'loop-stimulus-select-' + row.media.mediaId + '-checkbox'"
            [attr.aria-label]="'Select ' + row.media.name"
            (change)="onSelect(row.media.mediaId, $event.checked)"
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef><span>ID</span></th>
        <td mat-cell *matCellDef="let row">
          <span class="text__md fw__600">{{ row.media.sourceIndex | number: '3.0-0' }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef><span>Preview</span></th>
        <td mat-cell *matCellDef="let row"><empathy-shared-stimulus [stimulus]="row.preview" [readonly]="true" [width]="64" [height]="44" /></td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef><span>Stimulus name</span></th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              [formControl]="row.nameControl"
              [attr.aria-label]="'Name for ' + row.media.mediaId"
              [attr.data-testid]="'loop-stimulus-name-' + row.media.mediaId + '-input'"
              (blur)="onRename(row)"
            />
            <mat-error [attr.data-testid]="'loop-stimulus-name-' + row.media.mediaId + '-error'"><span>Stimulus name is required.</span></mat-error>
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="originalFile">
        <th mat-header-cell *matHeaderCellDef><span>Original file</span></th>
        <td mat-cell *matCellDef="let row">
          <div class="loop-stimuli-dialog__file caption">
            <fa-icon [icon]="faFile" /><span [title]="row.originalFilename ?? 'Unavailable'">{{ row.originalFilename ?? 'Unavailable' }}</span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef><span class="cdk-visually-hidden">Actions</span></th>
        <td mat-cell *matCellDef="let row">
          <div class="loop-stimuli-dialog__row-actions">
            <button
              mat-icon-button
              [attr.aria-label]="'Replace ' + row.media.name"
              [attr.data-testid]="'loop-stimulus-replace-' + row.media.mediaId + '-button'"
              (click)="onReplace(row.media.mediaId)"
            >
              <fa-icon [icon]="faRotate" />
            </button>
            <button
              mat-icon-button
              color="warn"
              [attr.aria-label]="'Remove ' + row.media.name"
              [attr.data-testid]="'loop-stimulus-remove-' + row.media.mediaId + '-button'"
              (click)="onRemove(row.media.mediaId)"
            >
              <fa-icon [icon]="faTrash" />
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
    @if (!media$().length) {
      <p class="loop-stimuli-dialog__empty"><span>No stimuli yet.</span></p>
    } @else if (!filtered$().length) {
      <p class="loop-stimuli-dialog__empty"><span>No matching stimuli.</span></p>
    }
  </div>
</div>
<div mat-dialog-actions class="loop-stimuli-dialog__actions">
  <button mat-stroked-button data-testid="loop-stimuli-close-footer-button" (click)="onClose()"><span>Close</span></button>
</div>
